"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _uniqueId = _interopRequireDefault(require("transmute/uniqueId"));

var _react = _interopRequireWildcard(require("react"));

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _constants = require("draft-plugins/lib/constants");

var _replaceSelectionWithText = _interopRequireDefault(require("draft-plugins/utils/replaceSelectionWithText"));

var _createOverlay = _interopRequireDefault(require("draft-plugins/components/overlay/createOverlay"));

var _TokenResults = _interopRequireDefault(require("./TokenResults"));

var _TokenResultItem = _interopRequireDefault(require("./TokenResultItem"));

var _TokenResultsZeroState = _interopRequireDefault(require("./TokenResultsZeroState"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var entityStrategy = _draftExtend.pluginUtils.entityStrategy;

var createTokenDecorator = function createTokenDecorator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      tokenClassName = _ref.tokenClassName,
      tokenStyle = _ref.tokenStyle;

  return function (props) {
    // eslint-disable-next-line react/prop-types
    var children = props.children;
    return _react.default.createElement("span", {
      className: tokenClassName,
      style: tokenStyle
    }, children);
  };
};

var defaultHTMLToToken = function defaultHTMLToToken(nodeName, node) {
  if (nodeName === 'span' && node.hasAttribute('data-token')) {
    return {
      value: parseInt(node.getAttribute('data-id'), 10),
      text: node.textContent
    };
  }

  return undefined;
};

var defaultTokenToHTML = function defaultTokenToHTML(_ref2) {
  var text = _ref2.text,
      value = _ref2.value;
  return "<span data-token data-id=\"" + value + "\">" + text + "</span>";
};

var defaultTokenStyle = {
  marginTop: '0',
  marginBottom: '0',
  padding: '0 4px',
  border: "1px solid " + colors.CALYPSO,
  borderRadius: '2px',
  background: colors.CALYPSO,
  fontSize: '12px',
  fontWeight: 700,
  color: colors.OLAF,
  textDecoration: 'none',
  fontStyle: 'normal',
  pointerEvents: 'none'
};

var TokenPlugin = function TokenPlugin() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      data = _ref3.data,
      _ref3$dataProp = _ref3.dataProp,
      dataProp = _ref3$dataProp === void 0 ? 'tokenOptions' : _ref3$dataProp,
      _ref3$onInsertProp = _ref3.onInsertProp,
      onInsertProp = _ref3$onInsertProp === void 0 ? 'onTokenInsert' : _ref3$onInsertProp,
      _ref3$trigger = _ref3.trigger,
      trigger = _ref3$trigger === void 0 ? '@' : _ref3$trigger,
      _ref3$textToToken = _ref3.textToToken,
      textToToken = _ref3$textToToken === void 0 ? function () {
    return [];
  } : _ref3$textToToken,
      _ref3$htmlToToken = _ref3.htmlToToken,
      htmlToToken = _ref3$htmlToToken === void 0 ? defaultHTMLToToken : _ref3$htmlToToken,
      _ref3$tokenToHTML = _ref3.tokenToHTML,
      tokenToHTML = _ref3$tokenToHTML === void 0 ? defaultTokenToHTML : _ref3$tokenToHTML,
      _ref3$maximumSearch = _ref3.maximumSearch,
      maximumSearch = _ref3$maximumSearch === void 0 ? 10 : _ref3$maximumSearch,
      _ref3$entityType = _ref3.entityType,
      entityType = _ref3$entityType === void 0 ? (0, _uniqueId.default)('TOKEN') : _ref3$entityType,
      _ref3$tokenStyle = _ref3.tokenStyle,
      tokenStyle = _ref3$tokenStyle === void 0 ? defaultTokenStyle : _ref3$tokenStyle,
      _ref3$addTrailingSpac = _ref3.addTrailingSpace,
      addTrailingSpace = _ref3$addTrailingSpac === void 0 ? false : _ref3$addTrailingSpac,
      _ref3$TokenResultsCom = _ref3.TokenResultsComponent,
      TokenResultsComponent = _ref3$TokenResultsCom === void 0 ? (0, _TokenResults.default)(_TokenResultItem.default, _TokenResultsZeroState.default) : _ref3$TokenResultsCom,
      _ref3$overlayPosition = _ref3.overlayPositioning,
      overlayPositioning = _ref3$overlayPosition === void 0 ? {
    placement: 'bottom right',
    targetAttachment: 'bottom right'
  } : _ref3$overlayPosition,
      _ref3$tokenClassName = _ref3.tokenClassName,
      tokenClassName = _ref3$tokenClassName === void 0 ? 'editor-token' : _ref3$tokenClassName,
      _ref3$onOpen = _ref3.onOpen,
      onOpen = _ref3$onOpen === void 0 ? _emptyFunction.default : _ref3$onOpen,
      _ref3$onClose = _ref3.onClose,
      onClose = _ref3$onClose === void 0 ? _emptyFunction.default : _ref3$onClose;

  var createEntityOptions = function createEntityOptions(option) {
    return [entityType, 'IMMUTABLE', option];
  };

  var TokenOverlay = (0, _createOverlay.default)({
    data: data,
    dataProp: dataProp,
    trigger: trigger,
    maximumSearch: maximumSearch,
    overlayPositioning: overlayPositioning,
    ResultsComponent: TokenResultsComponent
  });

  var Overlay = _react.default.createClass({
    displayName: "Overlay",
    propTypes: {
      editorState: _react.PropTypes.object.isRequired,
      onChange: _react.PropTypes.func.isRequired
    },
    selectOption: function selectOption(option, _ref4) {
      var offset = _ref4.offset,
          length = _ref4.length;
      var _this$props = this.props,
          editorState = _this$props.editorState,
          onChange = _this$props.onChange;
      var contentStateWithEntity = editorState.getCurrentContent();
      var entityKey;

      if (contentStateWithEntity.createEntity) {
        var _contentStateWithEnti;

        contentStateWithEntity = (_contentStateWithEnti = contentStateWithEntity).createEntity.apply(_contentStateWithEnti, (0, _toConsumableArray2.default)(createEntityOptions(option)));
        entityKey = contentStateWithEntity.getLastCreatedEntityKey();
      } else {
        entityKey = _draftJs.Entity.create.apply(_draftJs.Entity, (0, _toConsumableArray2.default)(createEntityOptions(option)));
      }

      var editorStateWithEntity = _draftJs.EditorState.set(editorState, {
        currentContent: contentStateWithEntity
      });

      var updatedEditorState = (0, _replaceSelectionWithText.default)({
        editorState: editorStateWithEntity,
        text: option.text || option.searchText || option.value,
        start: offset,
        end: offset + length,
        entityKey: entityKey,
        changeType: _constants.replaceSelectionChangeTypes.PUSH
      });

      if (addTrailingSpace) {
        var selectionState = updatedEditorState.getSelection();
        var blockWithToken = updatedEditorState.getCurrentContent().getBlockForKey(selectionState.getEndKey());
        var tokenEndOffset = blockWithToken.getCharacterList().findLastIndex(function (char) {
          return char.getEntity() === entityKey;
        });

        var contentWithTrailingSpace = _draftJs.Modifier.insertText(updatedEditorState.getCurrentContent(), selectionState.merge({
          anchorOffset: tokenEndOffset + 1,
          focusOffset: tokenEndOffset + 1
        }), ' ');

        updatedEditorState = _draftJs.EditorState.set(updatedEditorState, {
          currentContent: contentWithTrailingSpace,
          selection: selectionState.merge({
            anchorOffset: tokenEndOffset + 2,
            focusOffset: tokenEndOffset + 2
          })
        });
      }

      onChange(updatedEditorState);

      if (this.props[onInsertProp]) {
        this.props[onInsertProp](option);
      }
    },
    render: function render() {
      return _react.default.createElement(TokenOverlay, (0, _extends2.default)({}, this.props, {
        onOpen: onOpen,
        onClose: onClose,
        onSelect: this.selectOption
      }));
    }
  });

  var textToEntity = function textToEntity(text) {
    return textToToken(text) || [];
  };

  var htmlToEntity = function htmlToEntity() {
    var options = htmlToToken.apply(void 0, arguments);
    var createEntity = arguments.length >= 3 ? arguments.length <= 2 ? undefined : arguments[2] : _draftJs.Entity.create;

    if (options !== undefined && options !== null) {
      return createEntity.apply(void 0, (0, _toConsumableArray2.default)(createEntityOptions(options)));
    }

    return undefined;
  };

  var entityToHTML = function entityToHTML(entity, originalText) {
    if (entity.type === entityType) {
      return tokenToHTML(entity.data);
    }

    return originalText;
  };

  return (0, _draftExtend.createPlugin)({
    decorators: {
      strategy: entityStrategy(entityType),
      component: createTokenDecorator({
        tokenStyle: tokenStyle,
        tokenClassName: tokenClassName
      })
    },
    overlays: Overlay,
    textToEntity: textToEntity,
    htmlToEntity: htmlToEntity,
    entityToHTML: entityToHTML
  });
};

var _default = function _default() {
  if (arguments.length === 0) {
    return TokenPlugin({});
  }

  return TokenPlugin.apply(void 0, arguments);
};

exports.default = _default;
module.exports = exports.default;